/** Reproduce el tutorial sin el botón de descarga del navegador. */
const VideoTutorialEpayco = ({ src, className = 'w-full h-full' }) => (
    <video
        title="Tutorial registro ePayco"
        src={src}
        controls
        controlsList="nodownload noplaybackrate"
        disablePictureInPicture
        disableRemotePlayback
        playsInline
        preload="metadata"
        onContextMenu={(event) => event.preventDefault()}
        className={className}
    >
        Tu navegador no puede reproducir este video.
    </video>
);

export default VideoTutorialEpayco;
